import { fetch } from '@atlassian/eoc-fetch';

import {
	type SavedSearch,
	type SavedSearches,
	type SaveSearchRequest,
} from '../../../common/types';

export const getSavedSearchesEndpoint = () => {
	return fetch<SavedSearches>('/v1/alerts/saved-searches');
};

export const createSavedSearchEndpoint = (data: SaveSearchRequest) => {
	return fetch<SavedSearch>('/v1/alerts/saved-searches', {
		method: 'POST',
		body: data,
	});
};

export const deleteSearchEndpoint = (id: string) => {
	return fetch<never>(`/v1/alerts/saved-searches/${id}`, {
		method: 'DELETE',
		responseType: 'headers',
	});
};
